import React from "react";
import styles from "./LoadingIndicator.module.css";
import { clsx } from "clsx";

type LoadingIndicatorProps = {
	label?: string;
	size?: number; // diameter in px
	className?: string;
};

export const LoadingIndicator: React.FC<LoadingIndicatorProps> = ({
	label = "Loading",
	size = 44,
	className = "",
}) => {
	return (
		<div
			className={clsx(styles.loadingIndicator, className)}
			aria-live="polite"
			aria-busy="true"
			role="status"
			style={{ ["--size" as any]: `${size}px` }}
		>
			<div className={clsx(styles.spinnerWrapper)}>
				<div className={clsx(styles.spinner)} />
			</div>
			<span className={clsx(styles.visuallyHidden)}>{label}</span>
		</div>
	);
};
